// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Y8n0o"};